import React from "react";
import { Link } from "react-router-dom";
import logo from "../image/mg.png";
import facebook from "../image/facebook.png";
import instagram from "../image/instagram.png";
import youtube from "../image/youtube.png";

export default function Footer() {
  return (
    <>
      <div className="container-fluid footer-container">
        <footer className="footer">
          <div className="row footer-row">
            <div className="col-12 col-md-12 col-lg-5 footer-col about">
              <div className="text-start logo-sm-center">
                <img src={logo} alt="MeraGym - Find Gyms Near You" className="logo" />
              </div>

              <p className="footer-text mt-3">
                Mera Gym, is a place where you can find gym center or yoga
                center around you by searching in different cities. Explore top
                fitness centers and gyms near you on Meragym. Find the perfect
                workout facility to help you achieve your fitness goals. Start
                your fitness journey today!
              </p>

              <div className="social my-4">
                <div className="social-link">
                  <a
                    href="https://www.facebook.com/meragym/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img src={facebook} alt="MeraGym on Facebook" className="social-pic" />
                  </a>
                </div>
                <div className="social-link">
                  <a
                    href="https://www.instagram.com/meragymofficial/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img
                      src={instagram}
                      alt="MeraGym on Instagram"
                      className="social-pic"
                    />
                  </a>
                </div>
                <div className="social-link">
                  <a
                    href="https://www.youtube.com/@meragym/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img src={youtube} alt="MeraGym on YouTube" className="social-pic" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-3 col-lg-2 footer-col links">
              <h3 className="col-head">Useful Links</h3>
              <ul className="footer-list">
                <li>
                  <Link to="/plans">
                    <i className="bi bi-info-circle me-2"></i>Pricing
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy">
                    <i className="bi bi-shield-lock me-2"></i>Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-of-use">
                    <i className="bi bi-journal-text me-2"></i>Terms Of Use
                  </Link>
                </li>
                <li>
                  <Link to="/about-us">
                    <i className="bi bi-info-circle me-2"></i>About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us">
                    <i className="bi bi-chat-dots me-2"></i>Contact Us
                  </Link>
                </li>
                <li>
                  <a href="mailto:support@meragym.com">
                    <i className="bi bi-question-circle me-2"></i>Need Help
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-3 col-lg-2 footer-col links">
              <h3 className="col-head">Other Links</h3>
              <ul className="footer-list">
                <li>
                  <Link to="/varanasi/gym">
                    <i className="bi bi-buildings me-2"></i>All Gyms
                  </Link>
                </li>
                <li>
                  <Link to="/plans">
                    <i className="bi bi-building me-2"></i>Pricing
                  </Link>
                </li>
                <li>
                  <a href="mailto:support@meragym.com">
                    <i className="bi bi-headset me-2"></i>Support
                  </a>
                </li>
                <li>
                  <Link to="/login">
                    <i className="bi bi-box-arrow-in-right me-2"></i>Login
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-12 col-md-6 col-lg-3 footer-col subscribe">
              <h3 className="col-head">Connect with us</h3>
              <ul className="footer-list">
                <li>
                  <a href="mailto:support@meragym.com">
                    <i className="bi bi-envelope-at social-icon"></i>
                    support@meragym.com
                  </a>
                </li>
                <li>
                  <Link to="#call">
                    <i className="bi bi-telephone social-icon"></i>6390008506,
                    8920976591
                  </Link>
                </li>
                <li>
                  <Link to="#address">
                    <i className="bi bi-geo-alt social-icon"></i>Varanasi :
                    Kamachha, Varanasi | Noida : Sector 75, Noida
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="row copyright">
            <p>
              &copy; MERAGYM 2023 | All Right Reserved | Developed By
              <a
                href="https://techuptechnologies.com/meragym-free-gym-management-software/"
                rel="noreferrer"
                className="techup-link"
                target="_blank"
              >
                Techup Technologies
              </a>
            </p>
          </div>
        </footer>
      </div>
    </>
  );
}
